type WeChatAuthErrorAlertProps = {
  errorCode: string | null
  translate: (key: string) => string
}

export function WeChatAuthErrorAlert({
  errorCode,
  translate,
}: WeChatAuthErrorAlertProps) {
  if (!errorCode) {
    return null
  }

  if (errorCode === 'OAUTH_FAILED') {
    return (
      <div className="rounded-md border border-destructive/40 bg-destructive/5 px-3 py-2 text-sm text-destructive">
        {translate('wechat.errors.oauthFailed')}
      </div>
    )
  }

  return null
}
